import React from 'react';
import { View, type ViewProps } from 'react-native';

type DefaultScreenContainerViewProps = {
  children: React.ReactNode;
  className?: string;
  isScrollView?: false;
} & ViewProps;

const DefaultScreenContainerView: React.FC<DefaultScreenContainerViewProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <View className="flex-1 bg-light-100">
      <View
        className={`flex-1 bg-light-100 container mx-auto max-w-5xl ${className}`}
        {...rest}
      >
        {children}
      </View>
    </View>
  );
};

export default DefaultScreenContainerView;
